import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import style from "./MenuGroup.module.css";
import { Link, NavLink, useNavigate } from "react-router-dom";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

function MenuGroup(props) {
    const { t } = useTranslation();
    const { data } = props;

    const onTitleClick = (url) => {
        console.log(url);
        // props.closeMenu();
        window.location.href = url;
    }

    return (
        <VerticalFlex>
            <FlexChild height={50}>
                <div className={style.wrap}>
                    <HorizontalFlex>
                        <FlexChild width={30} >
                            <FontAwesomeIcon className={style.menuIcon} icon={fas[data.icon]} />
                        </FlexChild>
                        <FlexChild>
                            <p className={style.title}>{t(data.title)}</p>
                        </FlexChild>
                    </HorizontalFlex>
                </div>
            </FlexChild>
            <FlexChild>
                <div className={style.menuChild}>
                    <VerticalFlex>
                        {
                            data.children && data.children.map((menu) =>
                                <FlexChild key={menu.id} height={40}>
                                    <div className={style.childWrap}>
                                        {
                                            menu.logo ?
                                                <img className={style.brandLogo} src={menu.logo} onClick={() => onTitleClick(`/brand/${menu.id}`)}/>
                                                : <a className={style.childTitle} onClick={() => onTitleClick(menu.url) }>{t(menu.title.text ? menu.title.text : menu.title)}</a>
                                        }


                                    </div>
                                </FlexChild>)
                        }
                    </VerticalFlex>
                </div>

            </FlexChild>

        </VerticalFlex>
    );
}

export default MenuGroup;